const initialState = {
  isFetchingQrCode: false,
  fetchingQrCodeError: null,
  qrCode: null,

  isValidLocation: false,
  isValidatingLocation: false,
  validatingLocationError: null,
  hasValidatedLocation: false,

  isCheckingToken: false,
  isLoggedIn: false,
  isLoggingIn: false,
  loggingInError: null,
  isLoggingOut: false,
  loggingOutError: null,
  user: null,

  shift: null,
  isCheckingIfClockedIn: false,
  checkingIfClockedInError: null,
  isClockedIn: false,
  isClockingIn: false,
  clockingInError: null,
  isClockingOut: false,
  clockingOutError: null,
  ip: null,
};

export default initialState;
